import { sanitize } from 'dompurify';
export var allowedTags = [
    'strong',
    'em',
    'b',
    'i',
    'p',
    'code',
    'pre',
    'tt',
    'samp',
    'kbd',
    'var',
    'sub',
    'sup',
    'dfn',
    'cite',
    'big',
    'small',
    'address',
    'hr',
    'br',
    'div',
    'span',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'ul',
    'ol',
    'ul',
    'li',
    'dt',
    'dd',
    'abbr',
    'acronym',
    'a',
    'img',
    'blockquote',
    'del',
    'ins',
    'font',
];
export var allowedAttrs = [
    'href',
    'src',
    'width',
    'height',
    'alt',
    'cite',
    'datetime',
    'title',
    'class',
    'name',
    'xml:lang',
    'abbr',
    'color',
    'style',
];
export function clean(dirty) {
    return sanitize(dirty, {
        ALLOWED_TAGS: allowedTags,
        ALLOWED_ATTR: allowedAttrs,
    });
}
export var allowedTagsRegex = new RegExp(allowedTags.map(function (tag) { return "<" + tag + "\\b[^>]*>"; }).join('|'), 'i');
//# sourceMappingURL=html-util.js.map